function  regularCheck(parameter,type){
		let _this = this;
		// console.log("验证")
		let check;
		switch(type){
			case 'phone':
				check = /^[1][3|4|5|6|7|8|9][0-9]{9}$/;
				return check.test(parameter);
				break;
			case 'mail':
				check = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
				return check.test(parameter);
				break;
			case 'idCard':
				check = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
				return check.test(parameter);
				break;
			case 'number':
				check = /^(-?\d+)(\.\d+)?$/;
				return check.test(parameter);
				break;
			case 'integer':
				check = /^-?[1-9]+[0-9]*$|^0$/;
				return check.test(parameter);
				break;
			case 'chinese':
				check = /^[\u4E00-\u9FA5]+$/;
				return check.test(parameter);
				break;
			case '+integer':
				check = /^[1-9]\d*$/;
				return check.test(parameter);
				break;
			case '-integer':
				check = /^-[1-9]+[0-9]*$/;
				return check.test(parameter);
				break;
			case 'english':
				check = /^[a-zA-Z]*$/;
				return check.test(parameter);
				break;
				// 只能输入英文，数字，下划线
			case 'code':
				check = /^\w+$/;
				return check.test(parameter);
				break;
				
				// 只能输入英文，数字，下划线，横线
			case 'appCode':
					check = /^[\u4e00-\u9fa5A-Za-z0-9\-]*$/;
					return check.test(parameter);
					break;
			case 'adminPassword':
				check = /^[A-Za-z0-9-_]+$/;
					
				return check.test(parameter);
				break;	
			case 'IDCARD':
				check = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;		
				return check.test(parameter);
				break;
      case 'noChinese':
      	check = /[\u4E00-\u9FA5]/g;
      	return check.test(parameter);
      	break;  
        
		}
	}

module.exports = {
	regularCheck
}


// WEBPACK FOOTER //
// ./src/utils/regular.js